import styled from "styled-components";
import {
  CARD_BACKGROUND,
  COLORS,
  FONT_SIZE,
  FONT_WEIGHT,
  FONTS,
  TableCell,
} from "../../../constants/Styles";

export const RevisionsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  gap: 1rem;
`;

export const DiffCell = styled(TableCell)<{
  color?: string;
  backgroundColor?: string;
}>`
  ${({ color }) => color && `color: ${color};`}
  ${({ backgroundColor }) =>
    backgroundColor && `background-color: ${backgroundColor};`}
`;

export const BomDiffContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
`;

export const MessagesAndNotesContainer = styled.div`
  display: flex;
  gap: 2rem;
  width: 100%;
`;

export const MessagesAndNotesRevisionContainer = styled.div`
  flex: 1;
  border-radius: 0.5rem;
  ${CARD_BACKGROUND};
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
`;

export const SubTitle = styled.div`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size18};
  font-weight: ${FONT_WEIGHT.weight500};
  text-align: center;
`;

export const OffsetContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
`;

export const PhysicalDetailsDiffDetails = styled.div`
  color: ${COLORS.secondaryLight};
`;
